import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { Typography, Badge, Row, Col } from 'antd'
import Pagination from '../../components/Pagination'
import { PaginationDto, PaginationInDto, Sort } from '../../types/miscelaneos/pagination'
import { MenuProps } from 'antd/lib'
import { CSSProperties } from 'styled-components'
import { useDispatch } from 'react-redux'
import { Action, Dispatch } from 'redux'
import { OperationStatusDto } from '../../types/miscelaneos/operation-status.dto'

export interface DataDto<T> {
  title?: ReactElement<any, string> | string
  backUrl?: string
  breadCrumInfo?: string[]

  getContent?: ({ pagination, sort, group, filters }: {
    pagination?: PaginationDto
    sort?: Sort,
    group?: string
    filters?: { [key: string]: any }
  }) => Action<string>
  content?: any[]
  getContentStates?: OperationStatusDto
  afterGetContent?: () => void

  actions?: MenuProps['items']
  showSearch?: boolean
  tableTabTitle?: ReactElement[]
  contentHeight?: number
  contentScrollable?: boolean
  mobileMenuActions?: {
    label?: string | ReactElement
    url?: string
    action?: (data?: any) => void
    icon?: ReactElement | null
    featured: boolean
  }[]

  tableStyles?: { [key: string]: CSSProperties }

  columns?:
  | {
    key: string
    title: string
    fixed?: boolean
    style?: CSSProperties
    width?: string
    render?: (index: number, record: any) => React.ReactNode
  }[]
  | [];

  setTable?: (data: { _id: string; group?: string, total: number, results: any[] }[]) => void

  tableData?: T | null
  setTableData?: (data: T | null) => void

  tablePagination?: PaginationDto | null
  setTablePagination?: (pagination: PaginationDto | null) => void

  currentPage?: number
  itemsPerPage?: number

  search?: []

  sort?: {}
  initialSort?: Sort
  selectedSort?: Sort

  group?: { key: string, label: string }[]
  initialGroup?: string
  selectedGroup?: string

  hiddenColumns?: string[]
  initialHiddenColumns?: string[]
  selectedHiddenColumns?: string[]

  orderBy?: string[]
  initialOrderBy?: string
  selectedOrderBy?: string

  filters?: {
    key: string
    label: string
    showSearch?: boolean
    values: { label: string | JSX.Element; value: string }[]
    onChange: (action: 'remove_filter' | 'add_filter', name: string, value: any) => void
    isMulti?: boolean
    isClearable?: boolean
  }[]
  initialFilters?: { [key: string]: any }
  hardcodedFilters?: { [key: string]: any }
  selectedFilters?: { [key: string]: any }

  addFilter?: (param: { [key: string]: any }) => void
  removeFilter?: (key: string) => void
  cleanFilters?: () => void

  addGroup?: (key: string) => void
  removeGroup?: () => void

  setCurrentPage?: (page: number) => void
  setItemsPerPage?: (items: number) => void

  customTheme?: {
    content?: CSSProperties,
    breadcrumbs?: CSSProperties
  }
}

const initialValues: DataDto<any> = {
  title: '',
  backUrl: '',
  breadCrumInfo: undefined,

  getContent: undefined,
  content: undefined,

  contentHeight: 0,
  contentScrollable: true,

  actions: [],
  mobileMenuActions: [],

  tableStyles: {},
  columns: [],

  setTable: () => { },

  tableData: null,
  setTableData: () => { },

  tablePagination: null,
  setTablePagination: () => { },

  currentPage: 0,
  itemsPerPage: 20,

  search: [],

  sort: [],
  initialSort: undefined,
  selectedSort: undefined,

  group: [],
  initialGroup: '',
  selectedGroup: '',

  hiddenColumns: [],
  initialHiddenColumns: [],
  selectedHiddenColumns: [],

  orderBy: [],
  initialOrderBy: '',
  selectedOrderBy: '',

  filters: [],
  initialFilters: {},
  hardcodedFilters: {},
  selectedFilters: {},
  // addFilter: () => { },
  // removeFilter: () => { },
  // cleanFilters: () => { },
  // setCurrentPage: () => { },
  // setItemsPerPage: () => { },
}

interface ContexInitialValuesDto {
  data: DataDto<any>
  setProviderData: React.Dispatch<React.SetStateAction<DataDto<any>>>
  resetProviderData: () => void
  showLoading: boolean
  setShowLoading: React.Dispatch<React.SetStateAction<boolean>>
}

const contexInitialValues: ContexInitialValuesDto = {
  data: initialValues,
  setProviderData: () => { },
  resetProviderData: () => { },
  showLoading: false,
  setShowLoading: () => { },
}

export const DataProvidersContext = React.createContext(contexInitialValues)

export const useData = () => useContext(DataProvidersContext)

const DataProvider = ({ children, useLocation }) => {
  const dispatch = useDispatch<Dispatch<Action>>()
  const [data, setData] = useState<DataDto<any>>(initialValues)
  const [showLoading, setShowLoading] = useState<boolean>(contexInitialValues?.showLoading)
  const [currentPage, setCurrentPage] = useState<number>(0)
  const [itemsPerPage, setItemsPerPage] = useState<number | undefined>(initialValues?.itemsPerPage)
  const [selectedFilters, setSelectedFilters] = useState<{ [key: string]: any }>({})
  const [orderBy, setOrderBy] = useState<{ sortField: string, sortDirection: 'asc' | 'desc' }>()
  const [sort, setSort] = useState<{ sortField: string, sortDirection: 'asc' | 'desc' }>()
  const [selectedGroup, setSelectedGroup] = useState<string>('')
  const [rawTableData, setRawTableData] = useState<any>()
  const [tablePagination, setTablePagination] = useState<PaginationDto | null>()
  const [tableData, setTableData] = useState<any>()

  const addFilter = newFilter => {
    //console.log('Data provider', "Add Filter")
    setSelectedFilters(oldState => ({ ...oldState, ...newFilter }))
  }

  const removeFilter = key => {
    //console.log('Data provider', "Remove Filter")
    // Create a copy of the old state
    const newState = { ...selectedFilters }
    // Remove the filter with the specified key
    delete newState[key]
    setSelectedFilters(newState)
  }

  const cleanFilters = () => {
    //console.log('Data provider', "Clean Filters")
    setSelectedFilters({})
  }

  const addGroup = (field: string) => {
    //console.log('Data provider', "Add Group")
    setSelectedGroup(field)
  }

  const removeGroup = () => {
    //console.log('Data provider', "Remove Group")
    setSelectedGroup('')
  }

  // const groupData = (data, groupKey) => {
  ////   console.log('Data provider', "Group data")
  //   if (!groupKey) return { Todos: data }

  //   return data.reduce((acc, item) => {
  //     const key = item[groupKey]?.value?.nombre || item[groupKey] || 'Otros'
  //     if (!acc[key]) acc[key] = []
  //     acc[key].push(item)
  //     return acc
  //   }, {})
  // }

  const setTable = (data) => {
    //const groupedData = groupData(data, selectedGroup)
    //console.log('setTable', data)
    // setRawTableData(data)
    setTableData(data)
    //setTablePagination(pagination)
  }

  const setProviderData = (providerData) => {
    //console.log('Data provider', "Set provider data");

    // Set loading to true at the start
    setShowLoading(true);

    // Si es necesario hacer alguna operación asincrónica, hazla aquí, pero sin async/await en esta función.

    if (providerData?.initialFilters) {
      setSelectedFilters(providerData.initialFilters);
    }

    if (providerData?.initialGroup) {
      setSelectedGroup(providerData.initialGroup);
    }

    if (providerData?.initialSort) {
      setSort(providerData?.initialSort);
    }

    // Actualizamos el estado usando la función de `setData` directamente
    setData(prevData => ({
      ...prevData,
      ...providerData,
    }));

    // Set loading to false
    setShowLoading(false);
  };

  useEffect(() => {
    if (data?.getContent) {
      dispatch(
        data?.getContent({
          pagination: { limit: data?.itemsPerPage, page: data?.currentPage },
          ...(!!sort && { sort }),
          ...(!!selectedGroup && { group: selectedGroup }),
          filters: {
            ...(selectedFilters && selectedFilters),
            ...(data?.hardcodedFilters && data?.hardcodedFilters)
          },
        })
      )
    }
  }, [data?.hardcodedFilters, sort, currentPage, itemsPerPage, selectedFilters, selectedGroup])


  useEffect(() => {
    if (!!data.content) {
      let newData = data.content;

      if (tableData) {
        const mergedData: any[] = []

        data?.content?.forEach(newItem => {
          const existingGroup = tableData.find(item => item?.groupDetails?._id === newItem._id);

          if (existingGroup) {
            // Si el grupo ya existe, mergeamos los resultados
            existingGroup.results.push(...newItem.results);
            existingGroup.total += newItem.total; // Si quieres sumar los totales
          }

          mergedData.push(existingGroup)
        });

        newData = mergedData;
      }

      !!setTable && setTable(newData)
    }
  }, [data.content])

  const resetProviderData = () => {
    //console.log('Data provider', "Reset provider data")

    setRawTableData(null)
    setTableData(null)
    setTablePagination(null)
    setSelectedFilters({})
    setSelectedGroup('')
    setItemsPerPage(initialValues?.itemsPerPage)
    setCurrentPage(0)

    setData({
      ...initialValues,
      setCurrentPage,
      setItemsPerPage,
      addFilter,
      removeFilter,
      cleanFilters,
      tableData,
      setTableData,
    })
  }

  // useEffect(() => {
  ////   console.log('Data provider', "Set table data")
  //   if (!!rawTableData && !!selectedGroup) {
  //     setTable({ data: rawTableData, pagination: tablePagination })
  //   }
  // }, [selectedGroup, rawTableData])

  return (
    <DataProvidersContext.Provider
      value={{
        data: {
          ...data,
          currentPage,
          setCurrentPage,

          itemsPerPage,
          setItemsPerPage,

          selectedFilters,
          addFilter,
          removeFilter,
          cleanFilters,

          selectedGroup,
          addGroup,
          removeGroup,

          setTable,
          tableData,
          tablePagination,


        },
        showLoading,
        setShowLoading,
        setProviderData,
        resetProviderData,
      }}
    >
      {children}
    </DataProvidersContext.Provider>
  )
}

export default DataProvider
